import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(() => localStorage.getItem('visaalerts_token'));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (token) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      fetchUser();
    } else {
      setLoading(false);
    }
  }, [token]);

  const fetchUser = async () => {
    try {
      const response = await axios.get(`${API}/auth/me`);
      setUser(response.data);
    } catch (error) {
      console.error('Failed to fetch user:', error);
      logout();
    } finally {
      setLoading(false);
    }
  };

const login = async (email, password, turnstileToken) => {
  const response = await axios.post(`${API}/auth/login`, { email, password, turnstile_token: turnstileToken });
  const { token: newToken, user: userData } = response.data;
  
  localStorage.setItem('visaalerts_token', newToken);
  axios.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;
  setToken(newToken);
  setUser(userData);
  
  return userData;
};

  const register = async (name, email, password, country = 'Tunisia', visa_center = 'TLS') => {
    const response = await axios.post(`${API}/auth/register`, { name, email, password, country, visa_center });
    const { token: newToken, user: userData } = response.data;
    
    localStorage.setItem('visaalerts_token', newToken);
    axios.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;
    setToken(newToken);
    setUser(userData);
    
    return userData;
  };

  const logout = () => {
    localStorage.removeItem('visaalerts_token');
    delete axios.defaults.headers.common['Authorization'];
    setToken(null);
    setUser(null);
  };

  const updateUser = (userData) => {
    setUser(prev => ({ ...prev, ...userData }));
  };

  return (
    <AuthContext.Provider value={{
      user,
      token,
      loading,
      login,
      register,
      logout,
      updateUser,
      isAuthenticated: !!user,
      isAdmin: user?.is_admin || false,
      isSubscribed: user?.is_subscribed || false,
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export default AuthContext;
